<template>
  <div class="appointments_all_list">
    <div class="table-container">
      <div class="table-header item-parent" >
        <div class="item item-value">
          <span>
            {{ $t('user.name') }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ $t('user.email') }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ $t('patient.info.gender.key') }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ $t('patient.info.date_of_birth') }}
            ({{$t('patient.info.age')}})
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ $t('patient.condition.on_set_date') }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ $t('patient.condition.brain_lesions') }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            S.D
          </span>
        </div>
        <div class="item item-value">
          <span>
            mRS
          </span>
        </div>
        <div
            class="item item-value"
            style="-webkit-box-flex: 2;-ms-flex: 2 2 2rem;flex: 2 2 2rem;cursor: pointer;"
            @click="handleClickAllExcel($event)"
        >
          <span>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="vertical-align: middle;"
                v-tooltip="$t('unit.all')"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.62 15.93a.955.955 0 0 1-.33-.22l-4.44-4.45a.996.996 0 1 1 1.41-1.41L11 12.59V4c0-.55.45-1 1-1s1 .45 1 1v8.59l2.74-2.74a.996.996 0 1 1 1.41 1.41l-4.44 4.44c-.1.1-.21.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.07zm7.38 1c0-.55.45-1 1-1s1 .44 1 1V20c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-3.07c0-.55.45-1 1-1s1 .45 1 1V19h14v-2.07z"
                  fill="var(--grey70)"
              />
            </svg>
          </span>
        </div>
      </div>
      <div
          class="table-body item-parent"
          v-for="item in patientListFilter(tempData)"
          :key="item.seqPatient"
          :class="isChecked(item.seqPatient)? 'blue_border' : ''"
          @click="clickUser(item.seqPatient)"
          @contextmenu="$event.preventDefault()"
          @mousedown="handleMouseDown($event, item, false)"
      >
        <div class="item item-value">
          <span
              v-tooltip="item.patientInfo.patientInfoName"
          >
            {{ item.patientInfo.patientInfoName }}
          </span>
        </div>
        <div class="item item-value">
          <span
              v-tooltip="item.patientEmail"
          >
            {{ item.patientEmail }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ computedGender(item.patientInfo.patientInfoGender) }}
          </span>
        </div>
        <div class="item item-value">
          <span
              v-tooltip="item.patientInfo.patientInfoBirth ? `${moment(item.patientInfo.patientInfoBirth).locale($t('country')).format('ll')} (${moment().diff(item.patientInfo.patientInfoBirth, 'years')})` : '-'"
          >
            {{
              item.patientInfo.patientInfoBirth ? `${moment(item.patientInfo.patientInfoBirth).locale($t('country')).format('ll')} (${moment().diff(item.patientInfo.patientInfoBirth, 'years')})` : '-'
            }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{
              item.patientInfo.patientInfoOccurrenceDate ?
                  moment(item.patientInfo.patientInfoOccurrenceDate).locale($t('country')).format('ll') : '-'
            }}
          </span>
        </div>
        <div class="item item-value">
          <span>
              {{ item.patientInfo.patientInfoBrainLesionTitle}}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{
              item.patientInfo.patientInfoOccurrenceDate ? moment().diff(item.patientInfo.patientInfoOccurrenceDate, "days") + $t('unit.days') : '-'
            }}
          </span>
        </div>
        <div class="item item-value">
          <span>
            {{ item.patientStatus.patientStatusMRS === null || item.patientStatus.patientStatusMRS === "" ? 'N/A' : item.patientStatus.patientStatusMRS }}
          </span>
        </div>
        <div
            class="item item-value"
            style="-webkit-box-flex: 2;-ms-flex: 2 2 2rem;flex: 2 2 2rem;"
            @click="$event.stopPropagation()"
            @mousedown="handleMouseDown($event, item, item.patientEmail !== userEmail && item.isAccountSync === true)"
        >
          <span
              v-if="item.patientEmail === userEmail"
          >
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="vertical-align: middle;"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.17 4.16C13.17 6.46 11.3 8.33 9.00002 8.33C6.70002 8.33 4.83002 6.47 4.83002 4.17C4.83002 1.87 6.70002 0 9.00002 0C11.3 0 13.17 1.86 13.17 4.16ZM11.17 4.17C11.17 2.97 10.19 2 9.00002 2C7.81002 2 6.83002 2.97 6.83002 4.17C6.83002 5.37 7.80002 6.34 9.00002 6.34C10.2 6.34 11.17 5.37 11.17 4.17ZM9.11 9.35001H10.35C14.57 9.35001 18 12.78 18 17C18 17.55 17.55 18 17 18C16.45 18 16 17.55 16 17C16 13.88 13.47 11.35 10.35 11.35H9.11H8.89H7.65C4.54 11.35 2 13.88 2 17C2 17.55 1.55 18 1 18C0.45 18 0 17.55 0 17C0 12.78 3.43 9.35001 7.65 9.35001H8.89H9.11Z" fill="#000000"/>
            </svg>
          </span>
          <span
              v-else-if="item.isAccountSync === false"
              style="cursor: help;"
              v-tooltip="$t('alert.not_member_app')"
          >
              <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align: middle;"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 10C0 4.48 4.48 0 10 0C15.53 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10ZM12.14 6.46001C12.53 6.07001 13.16 6.07001 13.55 6.46001C13.94 6.85001 13.94 7.48001 13.55 7.87001L11.42 10L13.57 12.13C13.96 12.52 13.96 13.15 13.57 13.54C13.37 13.73 13.12 13.83 12.86 13.83C12.6 13.83 12.35 13.74 12.15 13.54L10.02 11.41L7.88997 13.54C7.68997 13.73 7.44001 13.83 7.18001 13.83C6.92001 13.83 6.66999 13.74 6.46999 13.54C6.07999 13.15 6.07999 12.52 6.46999 12.13L8.59999 10L6.46999 7.87001C6.07999 7.48001 6.07999 6.85001 6.46999 6.46001C6.85999 6.07001 7.48996 6.07001 7.87996 6.46001L10.01 8.59001L12.14 6.46001Z"
                    fill="#D83B01"
                />
              </svg>
          </span>
          <span
              v-else
          >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="vertical-align: middle;"
                v-tooltip="'Excel Export'"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.62 15.93a.955.955 0 0 1-.33-.22l-4.44-4.45a.996.996 0 1 1 1.41-1.41L11 12.59V4c0-.55.45-1 1-1s1 .45 1 1v8.59l2.74-2.74a.996.996 0 1 1 1.41 1.41l-4.44 4.44c-.1.1-.21.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.07zm7.38 1c0-.55.45-1 1-1s1 .44 1 1V20c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-3.07c0-.55.45-1 1-1s1 .45 1 1V19h14v-2.07z"
                  :fill="banList[item.patientInfo.seqMedicalRelation] === undefined || banList[item.patientInfo.seqMedicalRelation] === true ? '#0d469e' : 'var(--grey40)'"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {GENDER_TRANS} from "@/enum/lib"
import {
  excelExport,
  dataProcess,
} from "@/static";
import _API from "@/api";

export default {
  components: {},
  props: [
    'data',
  ],
  data() {
    return {
      checkedArr: [],
      userEmail: localStorage.getItem('userEmail'),
      tempData: this.data,
      isAccountSync: 'all',
      banList: {}
    }
  },
  methods: {
    ...mapActions(['inspectSelectPatient']),
    clickUser(seqPatient) {
      this.inspectSelectPatient(seqPatient);
      this.$router.push(`/patientList/details/home?id=${seqPatient}`);
    },
    isChecked(seqPatient) {
      for (let checkedValue of this.checkedArr) {
        if (seqPatient === checkedValue)
          return true;
      }
    },
    handleClick() {
      if (this.isAccountSync === 'all')
        this.isAccountSync = true;
      else if (this.isAccountSync === true)
        this.isAccountSync = false;
      else
        this.isAccountSync = 'all';
    },
    handleClickAllExcel(event) {
      event.stopPropagation();
      let excelDataApi = [];
      this.tempData
          .filter((item) => {
            return item.patientEmail !== this.userEmail
                && item.isAccountSync === true
                && (this.banList[item?.patientInfo?.seqMedicalRelation] === undefined || this.banList[item?.patientInfo?.seqMedicalRelation] === true)
          })
          .map((pItem) => {
            const seqMedicalRelation = pItem?.patientInfo?.seqMedicalRelation
            excelDataApi.push(_API.EXERCISE_LIST.getAllBySearchWordAndSeqMedicalRelation(0, 100000, seqMedicalRelation, {}, 1)
                .then((res) => {
                  return {
                    userName: pItem.patientInfo.patientInfoName,
                    userEmail: pItem.patientEmail,
                    data: dataProcess(res?.data, (lang) => {
                      return this.$t(lang)
                    })
                  }
                })
            )
          })

      Promise.all(excelDataApi)
          .then((data) => {
            excelExport(data, (lang) => {
              return this.$t(lang)
            }, '', true)
          })
    },
    handleMouseDown(event, item, checked) {
      event.stopPropagation();
      if (event.button === 0) {
        this.banList = {
          ...this.banList,
          [item?.patientInfo?.seqMedicalRelation]: true,
        };

        if (checked === true) {
          const seqMedicalRelation = item?.patientInfo?.seqMedicalRelation
          const userName = item?.patientInfo?.patientInfoName;
          const userEmail = item?.patientEmail;

          _API.EXERCISE_LIST.getAllBySearchWordAndSeqMedicalRelation(0, 100000, seqMedicalRelation, {}, 1)
              .then((res) => {
                return dataProcess(res?.data, (lang) => {
                  return this.$t(lang)
                })
              })
              .then((processData) => {
                excelExport([{
                  userName,
                  userEmail,
                  data: processData
                }], (lang) => {
                  return this.$t(lang)
                }, userEmail)
              })
              .finally(() => {
              })
        }
      } else if (event.button === 2) {
        this.banList = {
          ...this.banList,
          [item?.patientInfo?.seqMedicalRelation]: this.banList[item?.patientInfo?.seqMedicalRelation] === undefined ? false : !this.banList[item?.patientInfo?.seqMedicalRelation],
        };
      }
    },
    patientListFilter(patientData) {
      return patientData.filter((item) => {
        return item.check
      })
    },
  },
  watch: {
    isAccountSync: {
      deep: true,
      handler(newData) {
        if (newData === 'all')
          this.tempData = this.data;
        else
          this.tempData = this.data.filter(item => item.isAccountSync === newData && item.patientEmail !== this.userEmail);
      }
    },
    data: {
      deep: true,
      handler(newData) {
        this.tempData = newData;
      }
    }
  },
  computed: {
    computedGender() {
      return (patientInfoGender) => {
        return patientInfoGender ? this.$t(GENDER_TRANS[patientInfoGender].trans) : this.$t(GENDER_TRANS[null].trans)
      }
    }
  },
}
</script>

<style lang="scss">

.appointments_all_list {
  overflow: auto;

  .table-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 60px;
    width: 100%;

    .table-header {
      font-weight: bold;
      overflow: hidden;
    }

    .item-parent {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;

      &.row_select {
        background: var(--blue10);
        border: 1px solid var(--blue70);
        border-radius: 10px;
      }

      &.columns_2 {
        grid-column: 1/3;
      }

      &.row_2 {
        grid-row: 1/3;
      }

      .item {
        min-height: 60px;
        border-bottom: 1px solid var(--grey20);
        padding: 15px 0;
        overflow: hidden;

        &.item-title {
          flex: 1 1 1rem;
        }

        &.item-value {
          flex: 3 3 1rem;
        }

        &:nth-last-child(1) {
          border-right: none;
        }
      }
    }

    .table-header {
      background: var(--grey20);
      position: sticky;
      top: 0;

      .item-value:first-child {
        flex-grow: 4;
      }

      .item-value:nth-child(2) {
        flex-grow: 7;
      }
    }

    .item-parent {
      margin: 0;
    }

    .table-body {
      background: #f7f7f7;

      &:hover {
        transition: background-color 0.5s;
        background-color: #f7fbff;
      }

      .item-value:first-child {
        flex-grow: 4;
      }

      .item-value:nth-child(2) {
        flex-grow: 7;
      }
    }

    .table-header, .table-body {
      .item-value {
        line-height: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-left: 10px;
        padding-right: 10px;

        span {
        }
      }
    }
  }
}
</style>